import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    email,
    minLength,
    maxLength,
    numeric,
    sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import $ from "jquery";

export default {
    name: "adminRegister",
    components: {
        MainLayout
    },

    data() {
        return {
            signupForm: {
                name: this.name,
                email: this.email,
                phone_number: this.phone_number,
                password: this.password,
                password_confirmation: this.password_confirmation
            },
            submitted: false,
            error_email: ""
        };
    },

    validations: {
        signupForm: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            password: {
                required,
                minLength: minLength(6)
            },
            password_confirmation: {
                sameAsPassword: sameAs("password"),
                required
            }
        }
    },

    methods: {
        submitSignUp() {
            this.submitted = true;
            if (this.$v.signupForm.$invalid) {
                // console.log(this.$v.signupForm);
                console.log("signup validation error");
                return;
            }
            this.signupAdmin();
        },

        signupAdmin() {
            $("#block-btn").attr("disabled", true);
            var request = {
                name: this.signupForm.name,
                email: this.signupForm.email,
                phone_number: this.signupForm.phone_number,
                password: this.signupForm.password
            };
            axios.post("/admin/register", request)
            .then(response=> {
                if (response.data.msg) {
                    $("#block-btn").attr("disabled", false);
                    this.error_email = response.data.msg;
                    this.$notification.error("Admin Signup API Error", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$router.push({
                        name: "adminLogin"
                    });
                    location.reload();
                }
            });
        }
    }
};